import { render, staticRenderFns } from "./naj-box.vue?vue&type=template&id=1b9a8d84&scoped=true&"
import script from "./naj-box.vue?vue&type=script&lang=js&"
export * from "./naj-box.vue?vue&type=script&lang=js&"
import style0 from "./naj-box.vue?vue&type=style&index=0&id=1b9a8d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a8d84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
